import * as React from "react";
import styled from "styled-components";
import { AppTitle, AppText, FlexDiv } from "../../ui";
import theme from "../../../util/theme";
import { mobileSize } from "../../../util/variables";
import { OutboundLink } from "gatsby-plugin-google-gtag";
import { teamMembers } from "./teamMembers";
import linkedInLogo from "../../../content/img/icon/linkedin.png";

const OurTeamSegment: React.FC = React.memo(() => {
  return (
    <ContainerDiv>
      <ContentDiv>
        <WhiteAppTitle>Our Team</WhiteAppTitle>
        <MembersGrid>
          {/* Founder */}
          <Card key="DanielTerry" isFounder>
            <FounderContent>
              <CircularMemberImg src="/daniel.png" alt="Daniel Terry" />
              <div>
                <FlexDiv mobileJustify="center" align="center" gap={8}>
                  <MemberName>Daniel Terry</MemberName>
                  <OutboundLink href="https://www.linkedin.com/in/daniel-terry-18a9031/" target="_blank" rel="noopener noreferrer" style={{ lineHeight: 1 }}>
                    <LinkedInImg src={linkedInLogo} alt="Daniel Terry LinkedIn" />
                  </OutboundLink>
                </FlexDiv>
                <MemberTitle>Founder & Chairman</MemberTitle>
              </div>
            </FounderContent>
            <BioText>
              Daniel is the Founder, Chairman, and former CEO of Pocket Gems and Episode Interactive, leading mobile app companies that have each reached hundreds of millions of people and collectively raised over $150M from Sequoia Capital and Tencent. Daniel founded Pocket Gems in 2009 where he built a team of hundreds and led the company to release dozens of mobile gaming titles, establish multiple new breakout gaming categories and consistently maintain top grossing positions on mobile app stores for over a decade. In 2014, Daniel founded Episode Interactive which immediately defined the now billion dollar market for mobile interactive fiction where it remains the category leader with over 5 million weekly active readers and over 10 million registered content writers. Daniel holds a BA in computer science from Cornell and an MBA from Stanford.
            </BioText>
          </Card>
          {/* Team Members */}
          {teamMembers.map((item: typeof teamMembers[1]) => (
            <Card key={item.name.replace(" ", "")}>
              <CircularMemberImg src={`/${item.image}`} alt={item.name} />
              <FlexDiv align="center" gap={8} style={{ marginTop: 16 }}>
                <MemberName>{item.name}</MemberName>
                <OutboundLink href={item.url} target="_blank" rel="noopener noreferrer" style={{ lineHeight: 1 }}>
                  <LinkedInImg src={linkedInLogo} alt={`${item.name} LinkedIn`} />
                </OutboundLink>
              </FlexDiv>
              <MemberTitle>{item.title}</MemberTitle>
            </Card>
          ))}
        </MembersGrid>
      </ContentDiv>
    </ContainerDiv>
  );
});

const CircularMemberImg = styled.img`
  width: 120px;
  height: 120px;
  border-radius: 50%;
  object-fit: cover;
`;

const MemberName = styled(AppText as any)`
  font-family: ${theme.PRIMARY_FONT};
  font-size: 20px;
  line-height: 28px;
  margin: 0;
  text-align: center;
`;

const MemberTitle = styled(AppText as any)`
  font-weight: 500;
  font-size: 16px;
  line-height: 28px;
  color: ${theme.PRIMARY_COLOR};
  text-transform: uppercase;
  margin: 0px;
  text-align: center;
`;

interface IsFounderProp {
  isFounder?: boolean;
}

const Card = styled.div<IsFounderProp>`
  display: flex;
  flex-direction: column;
  align-items: ${props => (props.isFounder ? "start" : "center")};
  justify-content: ${props => (props.isFounder ? "start" : "center")};

  margin-right: 9px;
  border-radius: 16px;
  padding: 24px;
  background-color: ${theme.WHITE_COLOR};

  grid-column: ${props => (props.isFounder ? "span 2" : "auto")};
  @media ${mobileSize} {
    width: 100%;
    margin: 0px auto;
    grid-column: auto;
  }
`;

const FounderContent = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 16px;

  @media ${mobileSize} {
    flex-direction: column;
    align-items: center;
    margin: 0 auto;
  }
`;

const BioText = styled(AppText as any)`
  font-size: 15px;
  line-height: 21px;
  color: ${theme.BLACK_COLOR};
  margin: 0px;
  margin-top: 16px;
`;

const LinkedInImg = styled.img`
  width: 16px;
  height: 16px;
`;

const MembersGrid = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 24px;
  @media ${mobileSize} {
    grid-template-columns: 1fr;
  }
`;

const WhiteAppTitle = styled(AppTitle as any)`
  color: ${theme.BLACK_COLOR};
  width: 100%;
  margin-bottom: 40px;

  @media ${mobileSize} {
    margin-bottom: 12px;
  }
`;

const ContainerDiv = styled.div`
  background: ${theme.GREY_COLOR};
  width: 100%;
`;

const ContentDiv = styled.div`
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  max-width: 588px;
  margin: 80px auto;
  @media ${mobileSize} {
    padding-left: 24px;
    padding-right: 24px;
    margin: 28px auto 120px auto;
    flex-direction: column;
  }
`;
export { OurTeamSegment };
